import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/24/outline";
import LeftSection from "./leftSection";
import RightSection from "./rightSection";
import { ContentType } from "../../apiFunctions/sop/content_type";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/24/solid";
import MainButton from "../generic/buttons/mainButton";
import { connect, useDispatch, useSelector } from "react-redux";
import { setToggleResults as setReduxToggleResults } from "../../store/sop/actions";
export interface GenerationModalProps {}

export interface GenerationModalProps {
  openModal: boolean;
  setOpenModal: any;
  contentType?: ContentType;
}

const GenerationModal: React.FC<GenerationModalProps> = ({
  openModal,
  setOpenModal,
  contentType,
}) => {
  const [toggleResults, setToggleResults] = useState(false);
  const selector = useSelector((state: any) => state.sop);
  const dispath = useDispatch();

  // dispath(setReduxToggleResults(toggleResults));
  const closeModal = () => {
    setOpenModal(false);
  };

  return (
    <div className="font-Inter">
      <Transition.Root show={openModal} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 backdrop-blur-sm bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10">
            <div className="flex items-end justify-center md:p-4 text-center sm:items-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative w-screen md:w-[95vw] lg:w-[90vw] h-[95vh] max-h-[1200px] rounded-t-xl md:max-w-screen-2xl transform mt-16 md:mt-0 md:rounded-2xl bg-white text-left shadow-xl transition-all overflow-hidden">
                  <div className="md:bg-tootler-primary-50 sticky top-0 w-full z-10 md:border-b border-tootler-primary-400">
                    <div className="font-Inter font-semibold text-tootler-grey-900 text-base sm:text-2xl flex flex-col pl-6 lg:pl-8 pr-2 lg:pr-4 py-4">
                      {contentType?.title}
                    </div>
                    <XMarkIcon
                      className="bg-white border rounded-full p-2 w-10 h-10 absolute text-tootler-grey-600  hover:text-gray-500 top-2 md:top-4 right-4 cursor-pointer"
                      onClick={closeModal}
                    />
                  </div>

                  <div className="flex h-[95%]">
                    <div
                      className={` ${selector.toggleResults ? "hidden" : ""}
                      w-full h-[95%] md:block md:basis-2/5 lg:basis-1/3 `}
                    >
                      <LeftSection contentType={contentType} />
                    </div>

                    <div
                      className={`${
                        !selector.toggleResults ? "hidden" : ""
                      } h-[95%] md:block md:basis-3/5 lg:basis-2/3 px-6 overflow-y-auto`}
                    >
                      <RightSection
                        setOpenModal={setOpenModal}
                        contentType={contentType}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    toggleResults: state.sop.toggleResults,
  };
};

export default connect(mapStateToProps)(GenerationModal);
